export default "__VITE_PUBLIC_ASSET__f669df59__"